import React from 'react';

interface ParameterIconBoxProps {
  label: string;
  value?: string | number;
  icon: JSX.Element;
}

export const ParameterIconBox: React.FC<ParameterIconBoxProps> = ({label, value = 0, icon}) => {
  return (
    <div className="h-full w-[6rem] py-4 px-3 border border-transparent shadow-md flex flex-col items-center rounded-lgRadius">
      <div className="w-10 text-blue mb-4 pt-1">{icon}</div>
      <span>{value}</span>
      <span className="text-12 leading-4 text-darkGray text-center">{label}</span>
    </div>
  );
};
